<div id="statements-card" class="content-container">
  <div class="primary-container single">
    <dxo-card data-e2e="statements-list-card">
      <div class="header-container">
        <h2 class="card-body-header" data-e2e="StatementsCardHeader">Billing statements</h2>
        <div class="pay-statement-button">
          <dxo-button [primary]="true" text="Pay selected statements">
          </dxo-button>
        </div>
      </div>


      <!-- <span class="filter-results button-label-left">
        <dxo-button
        [text]="'Filter results'"
        [iconColor]="'dark-gray'"
        [variant]="'secondary'"
        [icon]="'filter_alt'"
        [iconPosition]="'right'"
      ></dxo-button>
    </span> -->
      <card-body>
        <dxo-tabs #tabs [default]="'Unpaid'"
        [dxoDataset]="[
      {
        selector: '.tablinks:nth-child(1)',
        data: { e2e: 'unpaid-tab' }
      },
      {
        selector: '.tablinks:nth-child(2)',
        data: { e2e: 'paid-tab' }
      },
      {
        selector: '.tablinks:nth-child(3)',
        data: { e2e: 'legacy-tab' }
      }
    ]">
          <dxo-tab [header]="'Unpaid'" [templateRef]="unpaid" />
          <dxo-tab [header]="'Paid'" [templateRef]="paid" />
          <dxo-tab [header]="'Legacy'" [templateRef]="legacy" />
        </dxo-tabs>
        <ng-template #unpaid>
          <dxo-data-table [headers]="tableHeaders" [items]="listBillingFancy" [showCardViewWhenMobile]="true"
            [dxoDataset]="[{ selector: 'dxo-table-cell > span', data: { pii: '', e2e: 'e2e-check' } }]">
            <ng-template dxoHeaderKey="checkbox">
              <span class="row-cell" tabindex="0">
                <dxo-checkbox [class.not-employee]="!isEmployee" class="selectItem" data-name="select item"
                  [(value)]="allSelected" (valueChange)="selectAll($event)" data-e2e="employee-checkbox"></dxo-checkbox>
              </span>
            </ng-template>
            <ng-template dxoHeaderKey="amountBalance">
              <span tabindex="0" class="sort-header" (click)="onClickTableHeader('amountBalance')"
                (keypress)="onClickTableHeader('amountBalance')">
                {{ amountBalance }}
                <dxo-icon [class.ascending]="
                    searchParameter.sortDirection === 'Ascending' && searchParameter.sortField === 'amountBalance'
                  " [color]="searchParameter.sortField === 'amountBalance' | getSortIconColor" [fontSize]="20"
                  [right]="true" data-e2e="amount-balance-sort">
                  {{ SortKey }}
                </dxo-icon>
              </span>
            </ng-template>
            <ng-template dxoHeaderKey="dueDateObj">
              <span tabindex="0" class="sort-header" (click)="onClickTableHeader('dueDate')"
                (keypress)="onClickTableHeader('dueDate')">
                {{ dueDate }}
                <dxo-icon [class.ascending]="
                    searchParameter.sortDirection === 'Ascending' && searchParameter.sortField === 'dueDate'
                  " [color]="searchParameter.sortField === 'dueDate' | getSortIconColor" [fontSize]="20"
                  [right]="true" data-e2e="due-date-sort">
                  {{ SortKey }}
                </dxo-icon>
              </span>
            </ng-template>
            <ng-template dxoHeaderKey="statementNumber">
              <span tabindex="0" class="sort-header" (click)="onClickTableHeader('statementNumber')"
                (keypress)="onClickTableHeader('statementNumber')">
                {{ statementNumber }}
                <dxo-icon [class.ascending]="
                    searchParameter.sortDirection === 'Ascending' && searchParameter.sortField === 'statementNumber'
                  " [color]="searchParameter.sortField === 'statementNumber' | getSortIconColor" [fontSize]="20"
                  [right]="true" data-e2e="statement-number-sort">
                  {{ SortKey }}
                </dxo-icon>
              </span>
            </ng-template>
            <ng-template dxoHeaderKey="invoicePeriod">
              <span tabindex="0" class="sort-header" (click)="onClickTableHeader('invoicePeriod')"
                (keypress)="onClickTableHeader('invoicePeriod')">
                {{ invoicePeriod }}
                <dxo-icon [class.ascending]="
                    searchParameter.sortDirection === 'Ascending' && searchParameter.sortField === 'invoicePeriod'
                  " [color]="searchParameter.sortField === 'invoicePeriod' | getSortIconColor" [fontSize]="20"
                  [right]="true" data-e2e="invoice-period-sort">
                  {{ SortKey }}
                </dxo-icon>
              </span>
            </ng-template>
            <ng-template dxoHeaderKey="billGroup">
              <span tabindex="0" class="sort-header" (click)="onClickTableHeader('billGroupNumber')"
                (keypress)="onClickTableHeader('billGroupNumber')">
                {{ billGroup }}
                <dxo-icon [class.ascending]="
                    searchParameter.sortDirection === 'Ascending' && searchParameter.sortField === 'billGroupNumber'
                  " [color]="searchParameter.sortField === 'billGroupNumber' | getSortIconColor" [fontSize]="20"
                  [right]="true" data-e2e="bill-group-sort">
                  {{ SortKey }}
                </dxo-icon>
              </span>
            </ng-template>
            <ng-template dxoHeaderKey="premiumCalcObj">
              <span tabindex="0" class="sort-header" (click)="onClickTableHeader('premiumCalc')"
                (keypress)="onClickTableHeader('premiumCalc')">
                {{ premiumCalc }}
                <dxo-icon [class.ascending]="
                    searchParameter.sortDirection === 'Ascending' && searchParameter.sortField === 'premiumCalc'
                  " [color]="searchParameter.sortField === 'premiumCalc' | getSortIconColor" [fontSize]="20"
                  [right]="true" data-e2e="premium-calc-sort">
                  {{ SortKey }}
                </dxo-icon>
              </span>
            </ng-template>
            <ng-template dxoHeaderKey="seeDetails"> </ng-template>
            <ng-template dxoHeaderKey="actions">
              {{ ActionsText }}
            </ng-template>
            <ng-template dxoKey="checkbox" let-item>
              <span class="row-cell">
                <dxo-checkbox [class.not-employee]="!isEmployee" class="selectItem" data-name="select item"
                  [value]="allSelected ? allSelected : item.selected"
                  (valueChange)="selectItem(item, $event)"></dxo-checkbox>
              </span>
            </ng-template>
            <ng-template dxoKey="amountBalance" let-item>
              <span class="row-cell amount-balance">
                <dxo-button [textButton]="true" [text]="item.amountBalanceUI"
                  (handleClick)="goStatementDetailPage(item)" data-e2e="amount-balance-button">
                </dxo-button>
              </span>
            </ng-template>
            <ng-template dxoKey="dueDateObj" let-item>
              <span class="row-cell">
                <dxo-status-indicator [color]="item.dueDateObj.color" [variant]="item.dueDateObj.variant"
                  [text]="item.dueDateObj.text" [link]="item.dueDateObj.linkText" [appendix]="item.dueDateObj.appendix"
                  [icon]="item.dueDateObj.icon" linkText=""></dxo-status-indicator>
              </span>
            </ng-template>
            <ng-template dxoKey="premiumCalcObj" let-item>
              <span class="row-cell">
                <dxo-status-indicator [color]="item.premiumCalcObj.color" [variant]="item.premiumCalcObj.variant"
                  [text]="item.premiumCalcObj.text" [link]="item.premiumCalcObj.linkText"
                  [icon]="item.premiumCalcObj.icon" [appendix]="item.premiumCalcObj.appendix"
                  linkText=""></dxo-status-indicator>
              </span>
            </ng-template>

            <ng-template dxoKey="billGroup" let-item>
              <span class="list-cell">{{ item.billGroupName }}</span>
              <span>{{ item.billGroupNumber }}</span>
            </ng-template>
            <ng-template dxoKey="seeDetails" let-item>
              <span class="row-cell see-details">
                <dxo-button-v2 [variant]="'secondary'" [size]="'small'" [label]="'See details'"
                  (handleClick)="goStatementDetailPage(item)"></dxo-button-v2>
              </span>
            </ng-template>
            <ng-template dxoKey="actions" let-item>
              <div class="row-cell menu-items">
                <dxo-menu [right]="true" [menuItems]="menuItems"></dxo-menu>
              </div>
            </ng-template>
          </dxo-data-table>
          <div class="paginator">
            Showing 5 of 5 results.
            <!-- We will enable server side pagination with API integration-->
            <!-- <dxo-server-pagination [itemCount]="totalResults" [currentPage]="searchParameter.page"
              [pageSize]="searchParameter.pageSize" (pageChange)="onPageChange($event)"
              (pageSizeChange)="onPageSizeChange($event)"></dxo-server-pagination> -->
          </div>
        </ng-template>
        <ng-template #paid> Work in progress </ng-template>
        <ng-template #legacy> Work in progress </ng-template>


      </card-body>
    </dxo-card>
  </div>
</div>
